import React from 'react';
import {Modal, Button} from 'semantic-ui-react';

function statusVehicle(status, validateTypeForm) {
  if (status === 'APROBADO') {
    return validateTypeForm ? 'VEHÍCULO CON CERTIFICADO' : 'VEHÍCULO CON GARANTÍA EXTENDIDA';
  }

  return status;
}

const ModalComfirm = ({handleModal, open, vehicle, validateTypeForm}) => {
  const {status} = vehicle;
  const messageNoCert = validateTypeForm ? 'VEHÍCULO NO CERTIFICADO' : 'VEHÍCULO SIN GARANTÍA EXTENDIDA';
  return (
    <Modal size={'mini'} open={open}>
      <Modal.Header>Estado del vehículo</Modal.Header>
      <Modal.Content>
        <p> Estado: {status && status !== 'HABILITADO' ? statusVehicle(status, validateTypeForm) : messageNoCert}</p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleModal} negative>
          Cerrar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ModalComfirm;
